import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=ee34ebce&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee34ebce')) {
      api.createRecord('ee34ebce', component.options)
    } else {
      api.reload('ee34ebce', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=ee34ebce&", function () {
      api.rerender('ee34ebce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-280zw54Rxwdxj/JS/videoIframe.vue"
export default component.exports